import _wrapAsyncGenerator from "@babel/runtime/helpers/wrapAsyncGenerator";
import _awaitAsyncGenerator from "@babel/runtime/helpers/awaitAsyncGenerator";
import _asyncGeneratorDelegate from "@babel/runtime/helpers/asyncGeneratorDelegate";
import _asyncIterator from "@babel/runtime/helpers/asyncIterator";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { getPatchedDataSchema } from '@tencent/data-schema-core';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { resolveVueInject } from "../../../lib/utils";
import { getTitleWithParentheses } from "../../../lib/utils/string";
export const INJECT_EXPR_INPUT_COMPLETION_PROVIDER_KEY = 'ui-core:expr-input-completion-provider';
const arrayMethods = getPatchedDataSchema({
  type: 'object',
  methods: [{
    id: 'includes',
    title: '判断是否包含',
    arguments: [{
      id: 'value',
      title: '要搜索的值'
    }],
    returnValue: {
      type: 'boolean'
    }
  }, {
    id: 'find',
    title: '找到符合条件的第一个元素，如果不存在，则返回 null',
    arguments: [{
      id: 'predictor',
      title: '一个判断函数，也可以是箭头函数，例如 `(item) => (item.name == "张三")`'
    }],
    returnValue: {
      description: '符合条件的第一个元素，或者 null'
    }
  }, {
    id: 'map',
    title: '将数组里每一个元素，逐个映射为别的东西，组成新的数组',
    arguments: [{
      id: 'mapper',
      title: '一个转化函数，也可以是箭头函数，例如 `(item) => (item.name)`'
    }],
    returnValue: {
      description: '新的数组'
    }
  }, {
    id: 'filter',
    title: '过滤，仅保留符合条件的元素',
    arguments: [{
      id: 'predictor',
      title: '一个判断函数，也可以是箭头函数，例如 `(item) => (item.name == "张三")`'
    }],
    returnValue: {
      description: '新的数组'
    }
  }, {
    id: 'findIndex',
    title: '找到符合条件的第一个元素的序号，如果不存在，则返回 -1',
    arguments: [{
      id: 'predictor',
      title: '一个判断函数，也可以是箭头函数，例如 `(item) => (item.name == "张三")`'
    }],
    returnValue: {
      description: '序号（零开始），或者-1表示没找到'
    }
  }]
}).methods;
const isBadVarName = text => !/^[a-zA-Z$_][\w$]*$/.test(text);
let ExprInputCompletionProvider = class ExprInputCompletionProvider extends Vue {
  get parentCompletionProvider() {
    // 第一次引用这个变量再计算继承，减少 Vue resolve 的时间
    return resolveVueInject(this.$parent, INJECT_EXPR_INPUT_COMPLETION_PROVIDER_KEY, null);
  }
  getCompletions(req) {
    var _this = this;
    return _wrapAsyncGenerator(function* () {
      var _ref;
      const {
        dataStub,
        inherit,
        customMethod
      } = _this;
      if (inherit === 'after' && _this.parentCompletionProvider) yield* _asyncGeneratorDelegate(_asyncIterator(_this.parentCompletionProvider.getCompletions(req)), _awaitAsyncGenerator);
      // --------------------
      const stub = (_ref = typeof dataStub === 'function' ? dataStub() : dataStub) === null || _ref === void 0 ? void 0 : _ref.getStubAtPath(req.path);
      if (stub) {
        switch (stub.type) {
          case 'object':
            for (const f of stub.definedFields) {
              const text = f.id;
              const isObject = f.type === 'object' || f.type === 'array';
              yield {
                text: String(text),
                displayText: getTitleWithParentheses(text, f.title),
                isObject,
                isBadVarName: isBadVarName(text),
                dataSchema: f
              };
            }
            break;
          case 'array':
            yield {
              text: 'length',
              displayText: getTitleWithParentheses('length', '列表项个数'),
              dataSchema: stub.arrItems
            };
            for (const method of arrayMethods) {
              yield {
                text: method.id,
                displayText: getTitleWithParentheses(method.id, method.title),
                isMethod: method
              };
            }
            break;
        }
        if (stub.schema.methods) {
          for (const method of stub.schema.methods) {
            yield {
              text: `${method.id}`,
              displayText: getTitleWithParentheses(method.id, method.title),
              isMethod: method,
              isBadVarName: isBadVarName(method.id)
            };
          }
        }
      }
      // --------------------
      if (typeof customMethod === 'function') yield* _asyncGeneratorDelegate(_asyncIterator(customMethod(req)), _awaitAsyncGenerator);
      // --------------------
      if (inherit === 'before' && _this.parentCompletionProvider) yield* _asyncGeneratorDelegate(_asyncIterator(_this.parentCompletionProvider.getCompletions(req)), _awaitAsyncGenerator);
    })();
  }
  getCompletionsForRaw(req) {
    var _this2 = this;
    return _wrapAsyncGenerator(function* () {
      const {
        inherit,
        customMethodForRaw
      } = _this2;
      if (inherit === 'after' && _this2.parentCompletionProvider) yield* _asyncGeneratorDelegate(_asyncIterator(_this2.parentCompletionProvider.getCompletionsForRaw(req)), _awaitAsyncGenerator);
      // --------------------
      if (typeof customMethodForRaw === 'function') yield* _asyncGeneratorDelegate(_asyncIterator(customMethodForRaw(req)), _awaitAsyncGenerator);
      // --------------------
      if (inherit === 'before' && _this2.parentCompletionProvider) yield* _asyncGeneratorDelegate(_asyncIterator(_this2.parentCompletionProvider.getCompletionsForRaw(req)), _awaitAsyncGenerator);
    })();
  }
  render(h) {
    return this.$slots.default || h();
  }
};
__decorate([Prop({
  default: 'after'
})], ExprInputCompletionProvider.prototype, "inherit", void 0);
__decorate([Prop()], ExprInputCompletionProvider.prototype, "dataStub", void 0);
__decorate([Prop()], ExprInputCompletionProvider.prototype, "options", void 0);
__decorate([Prop()], ExprInputCompletionProvider.prototype, "customMethod", void 0);
__decorate([Prop()], ExprInputCompletionProvider.prototype, "customMethodForRaw", void 0);
ExprInputCompletionProvider = __decorate([Component({
  name: 'ExprInputCompletionProvider',
  provide() {
    return {
      [INJECT_EXPR_INPUT_COMPLETION_PROVIDER_KEY]: this
    };
  }
})], ExprInputCompletionProvider);
export { ExprInputCompletionProvider };
export default ExprInputCompletionProvider;
//# sourceMappingURL=ExprInputCompletionProvider.js.map
